import {Injectable} from '@angular/core';
import {HttpService} from '../../../../../shared/services/http/http-client.service';
import {environment} from '../../../../../../environments/environment';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class CadastroVincularPrudutoService {

  constructor(private http: HttpService, private httpService: HttpService) {
  }

  saveProductFunc(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doPost('/employee/product', data, successHandle, errorHandle);
  }

  buscaLimiteGlobal(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/balanceLimit', data, successHandle, errorHandle);

  }

  taxasTermos(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/reuse/enterprise-product', data, successHandle, errorHandle);

  }

  buscaTaxas(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/returnReusedInterestRates', data, successHandle, errorHandle);

  }

  findEnterpriseRates(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/enterprise/rates/info', data, successHandle, errorHandle);
  }

  buscaSaldoRecebiveis(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/returnRetailReceivablesBalance', data, successHandle, errorHandle);
  }

  buscarTaxaAgiliza(data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/taxaAntecipacao', data, successHandle, errorHandle);

  }
  buscaBandeiras(empresaCnpj: any, produtId: any, data: any, successHandle: Function, errorHandle: Function) {

    return this.httpService.doGet('/enterprise/bandeiras/'+empresaCnpj+'/'+produtId, data, successHandle, errorHandle);

  }

  ratesEmitFirstLabelCopy(data: any, successHandle: Function, errorHandle: Function) {
    return this.httpService.doGet('/enterprise/ratesEmitFirstLabelCopy', data, successHandle, errorHandle);
  }

}
